import { Component, OnInit } from '@angular/core';
import { StoreType } from '../store-type';
import { ActivatedRoute } from '@angular/router';
import { StoreTypeService } from '../store-type.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-store-type-crud',
  templateUrl: './store-type-crud.component.html',
  styleUrls: ['./store-type-crud.component.css'],
  providers: [StoreTypeService]
})
export class StoreTypeCrudComponent implements OnInit {

	id: any = null;
	storeTypes: StoreType;
	msgs: Message[] = [];
	button_caption: string ="Сохранить"
 	button_icon:string ="fa fa-save";

  constructor(private storeTypeService: StoreTypeService,private activatedRoute: ActivatedRoute) { 
  		  activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
   		  	this.storeTypeService.getStoreTypeById(this.id).subscribe(response=>this.storeTypes=response['data']);	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }

  }

  ngOnInit() {
 		this.storeTypes={
 			id: "",
 			name: "",
      code: "",
 			available: false
 		}
  }

 crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.storeTypeService.createStoreType(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);});

   		  }else{
   		  	this.storeTypeService.updateStoreType(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);});
   		  }



  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/store_types/store-type-crud/store-type-crud.component.ts